import { AddRoomContentFormComponent } from './add-room-content-form';

export * from './add-room-content-form';


export const RoomContentOrganisms = [
    AddRoomContentFormComponent
];